/**
 * Gets the data for a placeholder triangle.
 *
 * @returns {{triangle: {}}}
 */
export function getPlaceHolderTriangleData() {
  return {
    triangle: {
      style: {
        color: '#000000',
        opacity: 1,
        rounded: 0,
      },
      border: {
        color: '#000000',
        opacity: 1,
        width: 0,
      }
    }
  };
}
